﻿import type { AssessmentQuestion } from "../types";

// ============================================================
// 25 道评估题 + 2 道隐藏校验题
// 来源: AI调查报告 — AI职业风险评估问卷-详细设计.md
// 每题标注数据出处（OpenAI/McKinsey/WEF）
// ============================================================

export const ASSESSMENT_QUESTIONS: AssessmentQuestion[] = [
  // ==========================================================
  // 模块 A: 职业与行业定位 (4题, 必答)
  // ==========================================================

  // --- A1. 职业类别 ---
  {
    id: 1,
    module: "A",
    question_number: "A1",
    question_text: "你当前从事的职业最接近以下哪个类别？",
    input_type: "single",
    options: [
      { label: "01", text: "管理和高管（CEO、总监、部门经理）", score: 0 },
      { label: "02", text: "商业和金融（会计、审计、财务分析、投资）", score: 0 },
      { label: "03", text: "计算机和信息技术（软件开发、数据分析、网络安全）", score: 0 },
      { label: "04", text: "建筑和工程（建筑师、土木工程师、电气工程）", score: 0 },
      { label: "05", text: "生命/物理/社会科学（生物学家、化学家、经济学家）", score: 0 },
      { label: "06", text: "社区和社会服务（社工、心理咨询师）", score: 0 },
      { label: "07", text: "法律（律师、法官、法律助理）", score: 0 },
      { label: "08", text: "教育和培训（教师、教授、培训师）", score: 0 },
      { label: "09", text: "艺术/设计/娱乐/媒体（作家、设计师、记者、摄影师）", score: 0 },
      { label: "10", text: "医疗诊断和治疗（医生、牙医、药剂师）", score: 0 },
      { label: "11", text: "医疗技术和辅助（护士、医学影像技师）", score: 0 },
      { label: "12", text: "保健支持（护理员、理疗助理）", score: 0 },
      { label: "13", text: "安保和执法（警察、消防员、安保人员）", score: 0 },
      { label: "14", text: "餐饮服务（厨师、服务员、调酒师）", score: 0 },
      { label: "15", text: "个人护理和服务（美容师、健身教练）", score: 0 },
      { label: "16", text: "销售（零售销售、房产中介、保险代理）", score: 0 },
      { label: "17", text: "行政和办公支持（行政助理、文员、客服）", score: 0 },
      { label: "18", text: "农林牧渔（农民、渔民、林业工人）", score: 0 },
      { label: "19", text: "建筑施工和开采（建筑工人、电工、管道工）", score: 0 },
      { label: "20", text: "设备安装和维修（机械维修、电器维修）", score: 0 },
      { label: "21", text: "生产制造（流水线操作、质检、焊接）", score: 0 },
      { label: "22", text: "运输和物流（司机、快递、仓储）", score: 0 },
      { label: "23", text: "翻译和语言服务（翻译、口译）", score: 0 },
      { label: "24", text: "市场营销和公关（市场专员、公关、品牌策划）", score: 0 },
      { label: "25", text: "人力资源（HR专员、招聘、培训）", score: 0 },
      { label: "26", text: "研究和数据分析（研究员、统计分析、数据科学家）", score: 0 },
      { label: "27", text: "创业/自由职业（自雇者、自媒体、独立咨询）", score: 0 },
      { label: "28", text: "学生（待就业）", score: 0 },
      { label: "29", text: "政府/公共服务（公务员、事业单位）", score: 0 },
      { label: "30", text: "其他（未在以上分类中）", score: 0 },
    ],
    weight: 0,
    dimension: "outlook",
    reversed: false,
    data_source: "O*NET 职业分类 (1,016 职业) — 简化为 30 大类",
  },

  // --- A2. 行业 ---
  {
    id: 2,
    module: "A",
    question_number: "A2",
    question_text: "你所在的行业是？",
    input_type: "single",
    options: [
      { label: "01", text: "互联网/科技", score: 85 },
      { label: "02", text: "金融/银行/保险", score: 80 },
      { label: "03", text: "零售/电商/消费品", score: 70 },
      { label: "04", text: "医疗/制药/生命科学", score: 60 },
      { label: "05", text: "教育/培训", score: 50 },
      { label: "06", text: "制造业", score: 45 },
      { label: "07", text: "能源/采矿", score: 40 },
      { label: "08", text: "房地产/建筑", score: 35 },
      { label: "09", text: "政府/公共服务", score: 30 },
      { label: "10", text: "农业/林业/渔业", score: 20 },
      { label: "11", text: "传媒/出版/广告", score: 80 },
      { label: "12", text: "法律/咨询", score: 70 },
      { label: "13", text: "物流/运输", score: 45 },
      { label: "14", text: "餐饮/酒店/旅游", score: 30 },
      { label: "15", text: "其他", score: 50 },
    ],
    weight: 0.40,
    dimension: "industry_impact",
    reversed: false,
    data_source: "McKinsey 行业经济影响分布 + WEF 2025 雇主技术转型预期",
  },

  // --- A3. 学历 ---
  {
    id: 3,
    module: "A",
    question_number: "A3",
    question_text: "你的最高学历是？",
    input_type: "single",
    options: [
      { label: "A", text: "初中及以下", score: 0 },
      { label: "B", text: "高中/中专/技校", score: 0 },
      { label: "C", text: "大专/高职", score: 0 },
      { label: "D", text: "本科", score: 0 },
      { label: "E", text: "硕士及以上", score: 0 },
    ],
    weight: 0,
    dimension: "task_exposure",
    reversed: false,
    data_source: "OpenAI Table 6 — 学历越高 LLM 暴露度越高 (Job Zone 4 beta=0.47 > Zone 1 beta=0.06)",
  },

  // --- A4. 工作年限 ---
  {
    id: 4,
    module: "A",
    question_number: "A4",
    question_text: "你在当前岗位（或同类岗位）的工作年限？",
    input_type: "single",
    options: [
      { label: "A", text: "不到 1 年", score: 0 },
      { label: "B", text: "1-3 年", score: 0 },
      { label: "C", text: "3-5 年", score: 0 },
      { label: "D", text: "5-10 年", score: 0 },
      { label: "E", text: "10 年以上", score: 0 },
    ],
    weight: 0,
    dimension: "task_exposure",
    reversed: false,
    data_source: "OpenAI Table 7 — 深度经验一定程度上降低替代风险（无培训岗 beta=0.42 vs 长期培训岗 beta=0.18）",
  },

  // ==========================================================
  // 模块 B: 工作任务构成 (6题) — 评分核心模块
  // ==========================================================

  // --- B1. 文字类任务比例 (Writing 系数 +0.467) ---
  {
    id: 5,
    module: "B",
    question_number: "B1",
    question_text: "在你的日常工作中，文字类任务（撰写文案/邮件/报告、翻译、编辑校对、内容创作）大约占多少比例？",
    input_type: "single",
    options: [
      { label: "A", text: "不到 10%", score: 10 },
      { label: "B", text: "10%-30%", score: 35 },
      { label: "C", text: "30%-50%", score: 60 },
      { label: "D", text: "超过 50%", score: 85 },
    ],
    weight: 0.22,
    dimension: "task_exposure",
    reversed: false,
    data_source: "OpenAI Table 5 — Writing 技能与 beta 暴露度系数 +0.467***（正向暴露第二高）",
  },

  // --- B2. 编程/数据处理比例 (Programming 系数 +0.623) ---
  {
    id: 6,
    module: "B",
    question_number: "B2",
    question_text: "你的工作中，编程和数据处理（写代码、数据分析、使用公式/SQL、自动化脚本）大约占多少比例？",
    input_type: "single",
    options: [
      { label: "A", text: "完全不涉及", score: 5 },
      { label: "B", text: "偶尔使用（<10%）", score: 25 },
      { label: "C", text: "经常使用（10%-40%）", score: 55 },
      { label: "D", text: "核心工作内容（>40%）", score: 80 },
    ],
    weight: 0.28,
    dimension: "task_exposure",
    reversed: false,
    data_source: "OpenAI Table 5 — Programming 技能与 beta 暴露度系数 +0.623***（所有技能中正向关联最强）",
  },

  // --- B3. 体力/动手操作比例 (Routine Manual 系数 -0.111) ---
  {
    id: 7,
    module: "B",
    question_number: "B3",
    question_text: "你的工作中，需要身体活动或动手操作（体力劳动、设备操控、现场安装、手工制作、面对面护理）的比例？",
    input_type: "single",
    options: [
      { label: "A", text: "几乎都是体力/动手（>70%）", score: 10 },
      { label: "B", text: "较多体力（40%-70%）", score: 25 },
      { label: "C", text: "部分体力（10%-40%）", score: 50 },
      { label: "D", text: "几乎纯脑力工作（<10%）", score: 80 },
    ],
    weight: 0.18,
    dimension: "task_exposure",
    reversed: false,
    data_source: "OpenAI Table 9 — Routine Manual 与 LLM 暴露度系数 -0.111***（体力越多暴露越低）",
  },

  // --- B4. 科学实验/复杂判断比例 (Science -0.230 + Critical Thinking -0.196) ---
  {
    id: 8,
    module: "B",
    question_number: "B4",
    question_text: "你的工作是否需要科学实验、现场判断或复杂推理（实验室研究、临床诊断、现场勘察、复杂法律判断、战略决策）？",
    input_type: "single",
    options: [
      { label: "A", text: "这是我的核心工作", score: 15 },
      { label: "B", text: "经常需要", score: 30 },
      { label: "C", text: "偶尔需要", score: 55 },
      { label: "D", text: "几乎不需要", score: 75 },
    ],
    weight: 0.12,
    dimension: "task_exposure",
    reversed: true,
    data_source: "OpenAI Table 5 — Science 系数 -0.230*** + Critical Thinking 系数 -0.196***（均负相关）",
  },

  // --- B5. 重复性标准化任务比例 (Routine Cognitive +0.069) ---
  {
    id: 9,
    module: "B",
    question_number: "B5",
    question_text: "你的工作中，重复性标准化任务（数据录入、表格审核、固定流程审批、格式转换、信息查询并回复）占多少？",
    input_type: "single",
    options: [
      { label: "A", text: "不到 10%", score: 15 },
      { label: "B", text: "10%-30%", score: 40 },
      { label: "C", text: "30%-60%", score: 65 },
      { label: "D", text: "超过 60%", score: 90 },
    ],
    weight: 0.10,
    dimension: "task_exposure",
    reversed: false,
    data_source: "OpenAI Table 9 — Routine Cognitive 与暴露度系数 +0.069***。WEF 2025 衰退岗位清单佐证",
  },

  // --- B6. 工作产出形式 ---
  {
    id: 10,
    module: "B",
    question_number: "B6",
    question_text: "你的工作主要产出的形式是什么？",
    input_type: "single",
    options: [
      { label: "A", text: "数字内容（文档/代码/设计稿/数据报表）", score: 85 },
      { label: "B", text: "分析报告和决策建议", score: 65 },
      { label: "C", text: "人际互动和关系维护（谈判/教学/咨询/管理）", score: 40 },
      { label: "D", text: "物理产品或现场服务", score: 15 },
    ],
    weight: 0.10,
    dimension: "task_exposure",
    reversed: false,
    data_source: "OpenAI E1/E2 暴露度框架 + McKinsey 模态分析（文本产出最先被影响）",
  },

  // ==========================================================
  // 模块 C: 技能与学习画像 (5题)
  // ==========================================================

  // --- C1. AI 时代增值技能 (多选, WEF 2025 技能排名) ---
  {
    id: 11,
    module: "C",
    question_number: "C1",
    question_text: "你目前具备以下哪些 [AI 时代增值技能]？（可多选）",
    input_type: "multi",
    options: [
      { label: "AI", text: "AI 和大数据应用能力（会使用 AI 工具、理解数据分析）", score: -12 },
      { label: "CYBER", text: "网络安全知识", score: -8 },
      { label: "TECH", text: "技术素养（理解新技术原理和趋势）", score: -8 },
      { label: "CREATIVE", text: "创意思维（能提出新颖方案和创造性解决问题）", score: -7 },
      { label: "RESILIENCE", text: "韧性和适应力（面对变化能快速调整）", score: -6 },
      { label: "LEADER", text: "领导力和社会影响力", score: -5 },
      { label: "LEARN", text: "好奇心和终身学习习惯", score: -5 },
      { label: "NONE", text: "以上都不具备", score: 15 },
    ],
    weight: 0.35,
    dimension: "skill_vulnerability",
    reversed: false,
    data_source: "WEF 2025 Key Findings — 技能增长排名 Top 7。63% 雇主认为技能差距是最大障碍",
  },

  // --- C2. 培训频率 ---
  {
    id: 12,
    module: "C",
    question_number: "C2",
    question_text: "过去 12 个月内，你参加过多少次与[新技术/AI/数字化]相关的培训或自学？",
    input_type: "single",
    options: [
      { label: "A", text: "0 次，也没有计划", score: 90 },
      { label: "B", text: "0 次，但有计划近期开始", score: 65 },
      { label: "C", text: "1-2 次", score: 45 },
      { label: "D", text: "3-5 次", score: 25 },
      { label: "E", text: "6 次以上，已形成持续学习习惯", score: 10 },
    ],
    weight: 0.25,
    dimension: "skill_vulnerability",
    reversed: false,
    data_source: "WEF 2025 — 59% 工人需培训，11% 不太可能获得再培训（就业前景日益危险）",
  },

  // --- C3. AI 工具使用频率 ---
  {
    id: 13,
    module: "C",
    question_number: "C3",
    question_text: "你目前使用 AI 工具（如 ChatGPT、Copilot、AI 写作助手、AI 设计工具等）辅助工作的频率？",
    input_type: "single",
    options: [
      { label: "A", text: "每天都用，已深度融入工作流", score: 15 },
      { label: "B", text: "每周使用几次", score: 30 },
      { label: "C", text: "偶尔尝试", score: 55 },
      { label: "D", text: "听说过但从不使用", score: 75 },
      { label: "E", text: "不了解这些工具", score: 90 },
    ],
    weight: 0.25,
    dimension: "skill_vulnerability",
    reversed: false,
    data_source: "McKinsey — AI 辅助客服可将解决率提升 14%/时。核心逻辑: 会用 AI = 被增强，不会用 = 被替代",
  },

  // --- C4. 手工技能重要性 ---
  {
    id: 14,
    module: "C",
    question_number: "C4",
    question_text: "你的核心工作技能中，手工操作、精细动手、体力耐力的重要性如何？",
    input_type: "single",
    options: [
      { label: "A", text: "极其重要（我的工作主要靠手和身体）", score: 15 },
      { label: "B", text: "比较重要", score: 30 },
      { label: "C", text: "有一定作用", score: 55 },
      { label: "D", text: "几乎不需要", score: 75 },
    ],
    weight: 0.15,
    dimension: "skill_vulnerability",
    reversed: false,
    data_source: "WEF 2025 — 手工技能需求净衰退最大，24% 雇主预见需求下降。OpenAI — Robot 暴露度与 LLM 负相关",
  },

  // --- C5. 职业提升时间预估 ---
  {
    id: 15,
    module: "C",
    question_number: "C5",
    question_text: "如果你的岗位在未来 3-5 年被 AI 部分替代，你认为自己通过职业提升适应相近岗位需要多长时间？",
    input_type: "single",
    options: [
      { label: "A", text: "3 个月内（我有明确的备选方向和能力）", score: 15 },
      { label: "B", text: "6 个月内", score: 35 },
      { label: "C", text: "1 年内", score: 55 },
      { label: "D", text: "不确定/没有想过", score: 80 },
    ],
    weight: 0.10,
    dimension: "adaptability",
    reversed: false,
    data_source: "WEF 2025 — 50% 雇主计划岗位转移，40% 计划缩减 AI 可自动化岗位",
  },

  // ==========================================================
  // 模块 D: 行业与组织环境 (4题)
  // ==========================================================

  // --- D1. 公司 AI 采纳度 ---
  {
    id: 16,
    module: "D",
    question_number: "D1",
    question_text: "你所在的公司/组织目前使用 AI 技术的情况？",
    input_type: "single",
    options: [
      { label: "A", text: "大规模部署，AI 已融入核心业务流程", score: 75 },
      { label: "B", text: "多个部门在试点使用", score: 55 },
      { label: "C", text: "个别团队在尝试", score: 35 },
      { label: "D", text: "有计划但尚未启动", score: 25 },
      { label: "E", text: "完全没有使用 AI", score: 20 },
    ],
    weight: 0.25,
    dimension: "industry_impact",
    reversed: false,
    data_source: "WEF 2025 Figure 1.2 — 86% 雇主预期 AI 将转变其业务",
  },

  // --- D2. 公司规模 ---
  {
    id: 17,
    module: "D",
    question_number: "D2",
    question_text: "你所在公司的规模？",
    input_type: "single",
    options: [
      { label: "A", text: "10 人以下（小微企业/工作室）", score: 30 },
      { label: "B", text: "10-100 人", score: 40 },
      { label: "C", text: "100-1,000 人", score: 50 },
      { label: "D", text: "1,000-10,000 人", score: 60 },
      { label: "E", text: "10,000 人以上", score: 70 },
    ],
    weight: 0.15,
    dimension: "industry_impact",
    reversed: false,
    data_source: "WEF 2025 — 规模越大 AI 采纳越积极，5万+员工公司 DEI 采纳率 95%",
  },

  // --- D3. 数字化成熟度 ---
  {
    id: 18,
    module: "D",
    question_number: "D3",
    question_text: "你所在行业的数字化成熟度如何？",
    input_type: "single",
    options: [
      { label: "A", text: "高度数字化（日常工作基本在电脑/手机上完成）", score: 80 },
      { label: "B", text: "中等数字化（线上线下各占一半）", score: 50 },
      { label: "C", text: "偏传统（以线下和实物操作为主）", score: 25 },
    ],
    weight: 0.20,
    dimension: "industry_impact",
    reversed: false,
    data_source: "OpenAI Section 4 — 信息处理行业暴露度高，制造/农业/采矿暴露度低",
  },

  // --- D4. 就业市场竞争 ---
  {
    id: 19,
    module: "D",
    question_number: "D4",
    question_text: "你所在地区的就业市场竞争程度？",
    input_type: "single",
    options: [
      { label: "A", text: "非常激烈（一线城市/热门行业）", score: 70 },
      { label: "B", text: "较为激烈", score: 55 },
      { label: "C", text: "一般", score: 40 },
      { label: "D", text: "竞争不太激烈（二三线/冷门行业）", score: 25 },
    ],
    weight: 0.0,
    dimension: "industry_impact",
    reversed: false,
    data_source: "WEF 2025 — 全球青年失业率 13%，高竞争地区转型压力更大",
  },

  // ==========================================================
  // 模块 E: 适应力与心态 (4题) — 反向计分（低分=好）
  // ==========================================================

  // --- E1. 新技术态度 ---
  {
    id: 20,
    module: "E",
    question_number: "E1",
    question_text: "面对需要学习的新技术工具或新工作方式，你的通常反应是？",
    input_type: "single",
    options: [
      { label: "A", text: "主动寻找并第一时间学习使用", score: 15 },
      { label: "B", text: "等公司组织培训后再学", score: 40 },
      { label: "C", text: "看同事用了效果好再跟进", score: 60 },
      { label: "D", text: "尽量避免，除非被强制要求", score: 85 },
    ],
    weight: 0.30,
    dimension: "adaptability",
    reversed: false,
    data_source: "WEF 2025 — 85% 雇主计划优先提升员工技能，主动学习是核心竞争力",
  },

  // --- E2. 备选职业方向 ---
  {
    id: 21,
    module: "E",
    question_number: "E2",
    question_text: "你是否有除本职工作外的第二技能或备选职业方向？",
    input_type: "single",
    options: [
      { label: "A", text: "有，且已经在产生收入或建立影响力", score: 10 },
      { label: "B", text: "有在探索和尝试", score: 30 },
      { label: "C", text: "考虑过但未行动", score: 55 },
      { label: "D", text: "完全没有", score: 80 },
    ],
    weight: 0.25,
    dimension: "adaptability",
    reversed: false,
    data_source: "WEF 2025 — 50% 雇主计划岗位转移，储备备选方向是个人对冲策略",
  },

  // --- E3. AI 态度 ---
  {
    id: 22,
    module: "E",
    question_number: "E3",
    question_text: "你对 AI 技术发展的整体态度是？",
    input_type: "single",
    options: [
      { label: "A", text: "积极拥抱，看到更多机遇", score: 15 },
      { label: "B", text: "谨慎乐观，机遇与挑战并存", score: 35 },
      { label: "C", text: "有些担忧焦虑", score: 60 },
      { label: "D", text: "排斥抗拒，希望它不要影响到我", score: 85 },
    ],
    weight: 0.20,
    dimension: "adaptability",
    reversed: false,
    data_source: "WEF 2025 — 心态决定你是'被提升'还是'被淘汰'的那一批",
  },

  // --- E4. 行业趋势关注 ---
  {
    id: 23,
    module: "E",
    question_number: "E4",
    question_text: "你是否关注所在行业的 AI 发展动态和趋势报告？",
    input_type: "single",
    options: [
      { label: "A", text: "经常主动阅读行业报告和趋势分析", score: 15 },
      { label: "B", text: "偶尔看到会读一下", score: 40 },
      { label: "C", text: "很少关注", score: 65 },
      { label: "D", text: "从不关注", score: 85 },
    ],
    weight: 0.15,
    dimension: "adaptability",
    reversed: false,
    data_source: "WEF 2025 — 信息差是最大的风险来源，关注趋势 = 提前预警",
  },

  // ==========================================================
  // 模块 V: 隐藏校验 (2题)
  // ==========================================================

  // --- V1. 面对面交流频率 (一致性校验) ---
  {
    id: 24,
    module: "V",
    question_number: "V1",
    question_text: "你的工作是否经常需要与人面对面交流沟通？",
    input_type: "single",
    options: [
      { label: "A", text: "几乎全部时间都在面对面沟通", score: 0 },
      { label: "B", text: "大部分时间", score: 0 },
      { label: "C", text: "约一半时间", score: 0 },
      { label: "D", text: "少部分时间", score: 0 },
      { label: "E", text: "几乎不需要面对面沟通", score: 0 },
    ],
    weight: 0,
    dimension: "task_exposure",
    reversed: false,
    data_source: "一致性校验 — 与 B3/B4/B6 交叉比对，检测人际密集型任务是否被充分评估",
  },

  // --- V2. AI 影响认知 (认知校准) ---
  {
    id: 25,
    module: "V",
    question_number: "V2",
    question_text: "你认为 AI 在未来 5 年内会影响多少比例的工作岗位？",
    input_type: "single",
    options: [
      { label: "A", text: "不到 10%（影响很小）", score: 0 },
      { label: "B", text: "10%-30%（部分岗位受影响）", score: 0 },
      { label: "C", text: "30%-50%（较大影响）", score: 0 },
      { label: "D", text: "50%-80%（影响很大）", score: 0 },
      { label: "E", text: "80% 以上（几乎全面影响）", score: 0 },
    ],
    weight: 0,
    dimension: "adaptability",
    reversed: false,
    data_source: "认知校准 — 检测用户对 AI 影响的认知偏差。WEF 预测 39% 技能将被转变",
  },

  // ==========================================================
  // 开放式问题 (选填，为未来 AI 个性化报告预留)
  // ==========================================================

  {
    id: 26,
    module: "V",
    question_number: "OE1",
    question_text: "用一句话描述你每天主要做什么工作？（选填，用于未来 AI 精准分析）",
    input_type: "text",
    options: [],
    weight: 0,
    dimension: "task_exposure",
    reversed: false,
    data_source: "开放式问题 — 为 AI 增强评分（第二层）预留数据字段",
  },
  {
    id: 27,
    module: "V",
    question_number: "OE2",
    question_text: "你认为 AI 最可能影响你工作中的哪个环节？（选填）",
    input_type: "text",
    options: [],
    weight: 0,
    dimension: "adaptability",
    reversed: false,
    data_source: "开放式问题 — 收集用户主观认知，与客观评分对比生成认知校准洞察",
  },
];

// --- 按模块获取题目 ---
export function getQuestionsByModule(module: string): AssessmentQuestion[] {
  return ASSESSMENT_QUESTIONS.filter((q) => q.module === module);
}

// --- 获取模块题目数 ---
export function getModuleQuestionCount(module: string): number {
  return ASSESSMENT_QUESTIONS.filter((q) => q.module === module).length;
}
